__turbopack_context__.v({
  "brush-stroke": "style-module-scss-module__mG6x2q__brush-stroke",
  "brush-stroke-1": "style-module-scss-module__mG6x2q__brush-stroke-1",
  "brush-stroke-1-content": "style-module-scss-module__mG6x2q__brush-stroke-1-content",
  "brush-stroke-2": "style-module-scss-module__mG6x2q__brush-stroke-2",
  "brush-stroke-3": "style-module-scss-module__mG6x2q__brush-stroke-3",
  "component": "style-module-scss-module__mG6x2q__component",
  "default-header": "style-module-scss-module__mG6x2q__default-header",
  "exp-header": "style-module-scss-module__mG6x2q__exp-header",
  "header-image": "style-module-scss-module__mG6x2q__header-image",
  "mobile-header": "style-module-scss-module__mG6x2q__mobile-header",
  "search-wrapper": "style-module-scss-module__mG6x2q__search-wrapper",
});
